// extracted by mini-css-extract-plugin
export default {"bottomTab":"BottomTab_bottomTab__tcW5C","tabItem":"BottomTab_tabItem__BmnfU","active":"BottomTab_active__AU0VQ"};